import React from 'react';
import FormStarProvider from './FormStarProvider';
import { Form, Modal } from 'antd';
import { fetchEditStarProvider } from '../../../../store/StarProviderSlice';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const EditStarProviders: React.FC<any> = (props) => {
  const { handleEditModal, openEditModal, getList, editModalData } = props;
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const handleEditSubmit = (data: any) => {
    dispatch(fetchEditStarProvider(data))
      .then(() => {
        handleEditModal();
        getList();
      })
      .catch(() => {});
  };

  return (
    <Modal
      open={openEditModal}
      destroyOnClose
      width={800}
      onCancel={handleEditModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Update Provider`}
    >
      <FormStarProvider
        form={form}
        mode={'edit'}
        editModalData={editModalData}
        handleEditSubmit={handleEditSubmit}
        handleEditModal={handleEditModal}
      />
    </Modal>
  );
};
export default EditStarProviders;
